export function validateZipCode (zipCode) {
    // ZipCode is a 5 digit number
    const regex = /^\d+$/;
    return regex.test(zipCode);
}

export function validateCountyName (countyName) {
    // CountyName is a real word
    const regex = /^[A-Za-z\s-]+$/;
    return regex.test(countyName);
}

export function validateSearchTerm (searchTerm) {
    // searchTerm is any real word
    const regex = /^[\p{L}\s-]+$/u;
    return regex.test(searchTerm);
}

export function validateName (name) {
    //name is any real name
    const regex = /^[A-Za-z]+$/;
    return regex.test(name);
}

export function validateUsername (username) {
    // username has no special characters
    const regex = /^[A-Za-z0-9\s\-_]+$/;
    return regex.test(username);
}

export function validatePassword (password) {
		//Password needs 1 Uppercase letter, 1 digit, and 1 non-word character of at least 8 chars in length
		const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/;
		return regex.test(password);
};

export function validateAdminPassword (password) {
		//Password needs 1 Uppercase letter, 1 digit, and 1 non-word character of at least 8 chars in length
		const regex = /^[0-9a-f]{16,}$/;
		return regex.test(password);
};

export function validateEmail (email) {
		//Password needs 1 Uppercase letter, 1 digit, and 1 non-word character of at least 8 chars in length
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regex.test(email);
};

export function validateURL (url) {
    // URL must be an https ending with a .thing
    // optional /*afterwards
    const regex = /^https:\/\/[a-z0-9\-_]+(\.[a-z0-9\-_]+)+(\/[^\s]*)?$/i;
    return regex.test(url);
}